
import { getConfig } from "../../config/config";

export const BANK_DEFAULT_COUNTRY = "US";

/**
 * Beneficiary Zip Code is optional — an empty value is accepted at any draw age.
 * A value the user does enter must be exactly this many digits.
 */
export const BANK_ZIPCODE_LENGTH = 5;

/**
 * Cut-off for the mandatory bank address. Draws submitted on or after this
 * instant must carry city/state/zipcode; drafts always validate. Older submitted
 * draws stay saveable so the draw team can still edit draws submitted before
 * the feature shipped.
 *
 * Mirrors DEFAULT_BANK_ADDRESS_MANDATORY_FROM in draw-service. Keep the ISO
 * date-only form: JS parses it as midnight UTC, matching the backend. A slashed
 * form ("2026/08/31") would parse as local midnight and mis-gate by the timezone
 * offset.
 *
 * Note: draw-service can override its cut-off via the BANK_ADDRESS_MANDATORY_FROM
 * env var. If that is ever set to something else in an environment, this constant
 * must be updated to match, or the two will disagree at the boundary.
 */
export const DEFAULT_BANK_ADDRESS_MANDATORY_FROM = "2026-08-31";

export const getBankAddressMandatoryFrom = (): Date => {
  const raw = getConfig()?.bankAddressMandatoryFrom;
  if (raw != null && String(raw).trim() !== "") {
    const parsed = new Date(String(raw).trim());
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }
  return new Date(DEFAULT_BANK_ADDRESS_MANDATORY_FROM);
};
